var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { dia, ui, shapes, layout } from '@joint/plus';
import { Link, Member } from './shapes';
export var init = function () {
    var cellNamespace = __assign(__assign({}, shapes), { Link: Link, Member: Member });
    var canvas = document.getElementById('canvas');
    var graph = new dia.Graph({}, { cellNamespace: cellNamespace });
    var paper = new dia.Paper({
        model: graph,
        width: 1000,
        height: 600,
        gridSize: 10,
        async: true,
        frozen: true,
        clickThreshold: 10,
        background: { color: '#F3F7F6' },
        cellViewNamespace: cellNamespace,
        defaultConnector: {
            name: 'straight',
            args: {
                cornerType: 'cubic',
            }
        },
        defaultAnchor: {
            name: 'modelCenter'
        },
        defaultLink: function () { return new Link(); }
    });
    var scroller = new ui.PaperScroller({
        paper: paper,
        autoResizePaper: true,
        cursor: 'grab',
        baseWidth: 1,
        baseHeight: 1,
        contentOptions: {
            allowNewOrigin: 'any',
            padding: 100,
            useModelGeometry: true
        }
    });
    var members = [
        createMember('Founder & Chairman', 'Pierre Omidyar', 'assets/images/1.png'),
        createMember('President & CEO', 'Margaret C. Whitman', 'assets/images/2.png'),
        createMember('President, PayPal', 'Mia Thompson', 'assets/images/3.png'),
        createMember('President, Ebay Global Marketplaces', 'Devin Wenig', 'assets/images/4.png'),
        createMember('Senior Vice President Human Resources', 'Olivia S. Skoll', 'assets/images/5.png'),
        createMember('Senior Vice President Controller', 'Sophia P. Westly', 'assets/images/6.png')
    ];
    var connections = [
        createLink(members[0], members[1]),
        createLink(members[1], members[2]),
        createLink(members[1], members[3]),
        createLink(members[1], members[4]),
        createLink(members[1], members[5])
    ];
    graph.addCells(__spreadArray(__spreadArray([], members, true), connections, true));
    canvas.appendChild(scroller.el);
    var treeLayout = new layout.TreeLayout({
        graph: graph,
        direction: 'R',
        parentGap: 75,
        siblingGap: 41
    });
    new ui.TreeLayoutView({
        paper: paper,
        model: treeLayout,
        className: 'tree-layout member-tree-layout',
        useModelGeometry: true,
        clone: function (element) {
            var clone = element.clone();
            clone.attr(['memberAddButtonBody', 'display'], 'none');
            clone.attr(['memberRemoveButtonBody', 'display'], 'none');
            clone.attr(['body', 'stroke'], 'none');
            return clone;
        },
        previewAttrs: {
            parent: {
                rx: 40,
                ry: 40
            }
        }
    });
    treeLayout.layout();
    scroller.render().centerContent({ useModelGeometry: true });
    paper.unfreeze();
    paper.on('element:pointermove', function (elementView) {
        paper.el.classList.add('hide-buttons');
        paper.el.classList.remove('show-buttons');
        elementView.model.attr(['body', 'strokeWidth'], 2);
    });
    paper.on('element:pointerup', function (elementView) {
        paper.el.classList.remove('hide-buttons');
        paper.el.classList.add('show-buttons');
        elementView.model.attr(['body', 'strokeWidth'], 1);
    });
    paper.on('blank:pointerdown', function (evt) { return scroller.startPanning(evt); });
    paper.on('element:member:add', function (elementView, evt) {
        evt.stopPropagation();
        // Adding a new member
        var newMember = createMember('Employee', 'New Employee', 'assets/images/1.png');
        var newConnection = createLink(elementView.model, newMember);
        graph.addCells([newMember, newConnection]);
        treeLayout.layout();
    });
    paper.on('element:remove', function (elementView, evt) {
        evt.stopPropagation();
        var preventReconnection = evt.ctrlKey || evt.metaKey;
        graph.startBatch('remove-member');
        if (preventReconnection) {
            elementView.model.remove();
            treeLayout.layout();
        }
        else {
            treeLayout.removeElement(elementView.model);
        }
        graph.stopBatch('remove-member');
    });
    paper.on('element:edit', function (elementView, evt) {
        evt.stopPropagation();
        // A member edit
        var inspector = new ui.Inspector({
            cellView: elementView,
            live: false,
            className: 'joint-inspector joint-member-inspector',
            inputs: {
                'attrs/label/text': {
                    type: 'text',
                    label: 'Name',
                    index: 1
                },
                'attrs/description/text': {
                    type: 'text',
                    label: 'Rank',
                    index: 2
                },
                'attrs/icon/xlinkHref': {
                    type: 'select-button-group',
                    target: '.joint-dialog .fg',
                    label: 'Avatar',
                    index: 3,
                    options: avatarOptions(elementView)
                }
            }
        });
        var dialog = new ui.Dialog({
            type: 'inspector-dialog',
            width: 350,
            title: 'Edit Member',
            className: 'joint-dialog joint-member-dialog',
            closeButton: false,
            content: inspector.render().el,
            buttons: [{
                    content: 'Cancel',
                    action: 'cancel',
                }, {
                    content: 'Apply',
                    action: 'apply'
                }]
        });
        dialog.on({
            'action:cancel': function () {
                inspector.remove();
                dialog.close();
            },
            'action:apply': function () {
                inspector.updateCell();
                inspector.remove();
                dialog.close();
            }
        });
        dialog.open();
    });
    // Tree Layout Rank Selection
    var currentDirection = treeLayout.get('direction');
    var options = [
        { value: 'L', content: 'Right-Left' },
        { value: 'R', content: 'Left-Right' },
        { value: 'T', content: 'Bottom-Top' },
        { value: 'B', content: 'Top-Bottom' }
    ].map(function (option) { return Object.assign({}, option, { selected: option.value === currentDirection }); });
    var directionPicker = new ui.SelectBox({
        width: 150,
        options: options
    });
    directionPicker.on('option:select', function (option) {
        graph.getCells().forEach(function (cell) { return cell.unset('direction'); });
        treeLayout.set('direction', option.value);
        treeLayout.layout();
        if (!paper.hasScheduledUpdates()) {
            return;
        }
        paper.once('render:done', function () {
            scroller.scrollToContent({ useModelGeometry: true });
        });
    });
    var direction = document.getElementById('orgchart-direction');
    direction.appendChild(directionPicker.render().el);
    document.getElementById('orgchart-direction-container').style.visibility = 'visible';
};
var createMember = function (rank, name, image) {
    return new Member({
        attrs: {
            label: {
                text: name
            },
            description: {
                text: rank
            },
            icon: {
                xlinkHref: image
            }
        }
    });
};
var createLink = function (source, target) {
    return new Link({
        source: { id: source.id },
        target: { id: target.id },
    });
};
var avatarOptions = function (elementView) {
    var options = [];
    var ASSETS_LENGTH = 10;
    for (var i = 1; i <= ASSETS_LENGTH; i++) {
        var asset = "assets/images/".concat(i, ".png");
        var option = {
            icon: asset,
            value: asset,
            selected: elementView.model.attr(['icon', 'xlinkHref']) === asset
        };
        options.push(option);
    }
    return options;
};
